import { useState, useEffect, useRef } from "react";
import { XIcon } from "lucide-react";
import { motion } from "framer-motion";
import GlobalContactWhatsappFloating from "./GlobalContactWhatsappFloating";

export default function GlobalCompoVideo() {
  const [showVideo, setShowVideo] = useState(false);
  const [showGif] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showSecondLogo, setShowSecondLogo] = useState(false);
  const [isPaused, setIsPaused] = useState(false); // New state for video pause/play
  const videoRef = useRef<HTMLVideoElement | null>(null); // Ref for the video element

  // Trigger logo fade-in after a short delay
  useEffect(() => {
    let timeout1: NodeJS.Timeout;
    let timeout2: NodeJS.Timeout;

    if (showVideo) {
      setLoading(true);
      setShowSecondLogo(false);

      timeout1 = setTimeout(() => setShowSecondLogo(true), 1000);
      timeout2 = setTimeout(() => setLoading(false), 3000);
    }

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [showVideo]);

  // Toggle play/pause based on isPaused state
  useEffect(() => {
    if (videoRef.current) {
      if (isPaused) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
    }
  }, [isPaused]);

  return (
    <div className="fixed bottom-3 right-3 lg:bottom-7 lg:right-7 z-50">
      {showGif && (
        <div className="relative">
          <div
            onClick={() => setShowVideo(true)}
            className="w-[7rem] h-[7rem] lg:w-[15rem] lg:h-[15rem] shadow-lg rounded-full overflow-hidden border-4 border-[#FEC400] relative transition-transform hover:scale-105 cursor-pointer"
          >
            <img
              src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-rumah-di-bekasi_gif.gif?tr=w-112,h-112,q-50,fo-auto"
              alt="arsinesia gif"
              width="112"
              height="112"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/30 flex items-center justify-center pointer-events-none" />
          </div>
        </div>
      )}

      {showVideo && (
        <div className="fixed z-40 pb-[4rem] p-[1rem] py-[1.5rem] right-0 bottom-0 w-full lg:w-[30vw] lg:h-[40vh] lg:max-w-[30vw] lg:max-h-[40vh] bg-black rounded-t-xl lg:rounded-tl-xl shadow-lg overflow-hidden">
          <button
            onClick={() => setShowVideo(false)}
            aria-label="Close"
            className="absolute top-2 right-2 bg-gradient-to-r from-[#a10707] to-[#ff514b] via-[#eb1811] text-white rounded-full w-6 h-6 p-1 flex items-center justify-center z-50 hover:bg-red-600"
          >
            <XIcon strokeWidth={5} />
          </button>

          {/* Buffering Animation */}
          {loading ? (
            <div className="relative w-full h-full flex items-center justify-center">
              <div className="relative w-48 h-48 flex items-center justify-center">
                {/* Fast Spinning Icon Logo (1 spin) */}
                <motion.img
                  src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita-logo-cube.gif?updatedAt=1744029262154"
                  alt="Main Icon Logo"
                  className="absolute w-32 h-32 z-20"
                  initial={{ rotate: 0 }}
                  transition={{ duration: 0.8, ease: "easeInOut" }}
                />

                {/* Typography Logo slides in AFTER spin completes */}
                {showSecondLogo && (
                  <motion.img
                    src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita-logo-yellow.webp"
                    alt="Typography Logo"
                    className="absolute pt-[9rem] w-48 h-auto z-10"
                    initial={{ x: -100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                  />
                )}
              </div>
            </div>
          ) : (
            <video
              ref={videoRef} // Attach ref to video element
              controls
              autoPlay
              playsInline
              className="w-full h-full object-cover rounded-lg"
              src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-rumah-di-bekasi_video.mp4"
            />
          )}

          {/* Button to pause/play the video */}
          {!loading && (
            <div
              onClick={() => setIsPaused(!isPaused)}
              className="  text-white rounded-full"
            >
              <GlobalContactWhatsappFloating />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
